import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { H1 } from '#app/components/typography/h1.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'H1',
}

const component: componentProps = {
	name: 'H1',
	shortName: 'H1',
	fileName: 'h1',
	category: 'typography',
	description: ['H1 heading component.'],
	features: ['Drop-in replacement for the native <h1> element.', "Opts-in to your design system's typographic styles."],
	usage: `<H1>This is an H1 heading</H1>`,
	parts: [],
	styling: `.h1 {
	@apply text-muted-900 mb-fluid-13 text-fluid-4xl max-w-prose font-sans font-bold capitalize;
	/* Typographical elements after h1 */
	& + .h2,
	& + .p {
		@apply mt-0;
	}
}`,
}

export const loader = async () => {
	const source = await readSource({ category: component.category, fileName: component.fileName })
	return json({ source })
}

const HeadingRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<H1>This is an H1 heading</H1>
			<Features features={features} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default HeadingRoute
